import { trackEvent } from '@raisin/events-tracking';
import { getDistributor } from '@raisin/cp-utils';
import {
  WithRequired,
  CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  CustomerPortalEvent,
  CUSTOMER_PORTAL_COMPONENT,
} from 'eventsTracking';
import { getAuthValue, guardDistributorValue } from '../../utils';
import { ProductType } from 'api/dbs/models';

export type OnProductCardClickedParams = WithRequired<
  { isLoggedIn: boolean; bankId: string; depositType: ProductType },
  'productId'
>;

const createCardClickedEvent = ({
  productId,
  isLoggedIn,
  bankId,
  depositType,
}: OnProductCardClickedParams): CustomerPortalEvent => ({
  ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  component: CUSTOMER_PORTAL_COMPONENT.PRODUCT_CARDS,
  eventName: 'card_clicked',
  object: 'card',
  action: 'clicked',
  productId,
  customerGroup: guardDistributorValue(getDistributor()),
  customAttribute1: getAuthValue(isLoggedIn),
  customAttribute2: bankId,
  customAttribute3: depositType,
});

export const onCardClicked = (params: OnProductCardClickedParams) =>
  trackEvent(createCardClickedEvent(params));
